export enum WorkspaceDocumentPickerMode {
  EDIT = 'edit',
  VIEW = 'view',
}
